import React from 'react';
import * as PropTypes from 'prop-types';
import { constants } from 'cv-react-core';
import { ThreeOneRightForm as ThreeOneRightFormBase } from 'cv-library-react-web';

import getStyles from './ThreeOneRightForm.styles';

const ThreeOneRightForm = (props) => {
    const {
        formElements,
        onResizeStop,
        ...rest
    } = props;
    const styles = getStyles();
    const { ui } = constants;

    const handleResizeStop = (e, dir, ref) => {
        const viewId = ref.getAttribute('viewid');
        const {
            style: {
                width,
                height,
            },
        } = ref;
        onResizeStop(viewId, width, height);
    };

    return (
        <ThreeOneRightFormBase
            contextStyles={ styles }
            formElements={ formElements }
            onResizeStop={ handleResizeStop }
            scrollIdentifier={ ui.SCROLL_CONTAINER }
            { ...rest } />
    );
};

ThreeOneRightForm.propTypes = {
    formElements: PropTypes.arrayOf(PropTypes.element),
    onResizeStop: PropTypes.func,
};

ThreeOneRightForm.defaultProps = {
    formElements: {},
};

export default ThreeOneRightForm;
